import moment from 'moment';

export const getInstructorsFromVspPageData = (vspPageData: any) => {
  const allInstructors = vspPageData.map((course: any) => course.instructors).flat();
  const seenIds = new Set<string>();

  return allInstructors.filter((instructor: any) => {
    if (seenIds.has(instructor.id)) {
      return false;
    }
    seenIds.add(instructor.id);
    return true;
  });
};

export const getTimeDurationForVspCourse = (vspCourseData: any): number => {
  const totalDuration = moment.duration(vspCourseData.material.totalDuration);
  return Math.round(totalDuration.asHours());
};

const getPartnersFromVspModuleLecturesData = (vspModuleLecturesData: any) => {
  const partnerMap = new Map<string, { name: string; logoUrl: string }>();
  vspModuleLecturesData?.forEach((lecture: any) => {
    lecture?.partners?.forEach((partner: any) => {
      if (!partnerMap.has(partner.id)) {
        partnerMap.set(partner.id, {
          name: partner.name,
          logoUrl: partner.squareLogo,
        });
      }
    });
  });
  return Array.from(partnerMap.values());
};

export const getModulesDataFromVspCourseData = (vspCourseData: any) => {
  const modules = vspCourseData.material.weeks;
  const modulesData = modules
    .map((module: any) => {
      if (!module.lectures) {
        return null;
      }
      return {
        name: module.name,
        duration: Math.round(moment.duration(module.totalDuration).asHours()),
        partners: getPartnersFromVspModuleLecturesData(module.lectures),
      };
    })
    .filter(Boolean);
  return modulesData;
};

export const getSkillGoalsFromVspPageData = (vspPageData: any) => {
  if (!vspPageData || !Array.isArray(vspPageData)) {
    return {
      totalHours: 0,
      modulesCount: 0,
    };
  }

  const totalHours = vspPageData.reduce((total: moment.Duration, course: any) => {
    const courseDuration = course.material.totalDuration;
    return total.add(moment.duration(courseDuration));
  }, moment.duration(0));
  const roundedTotalHours = Math.round(totalHours.asHours());

  return {
    totalHours: roundedTotalHours,
    modulesCount: vspPageData.length,
  };
};

export const getAssessmentsDataFromVspPageData = (vspPageData: any) => {
  if (!vspPageData || !Array.isArray(vspPageData)) {
    return {
      totalAssignments: 0,
      totalQuizzes: 0,
    };
  }
  const assessmentsData = {
    totalAssignments: 0,
    totalQuizzes: 0,
  };

  vspPageData.forEach((course: any) => {
    course.material.weeks?.forEach((week: any) => {
      week.assessments?.forEach((assessment: any) => {
        if (assessment.typeName === 'ASSIGNMENT') {
          assessmentsData.totalAssignments++;
        }
        if (assessment.typeName === 'QUIZ') {
          assessmentsData.totalQuizzes++;
        }
      });
    });
  });

  return assessmentsData;
};
